import React from 'react';
import { Box, Container, useTheme } from '@mui/material';
import { pageHorizontalPadding } from '../Layout/Layout';

/**
 * PageWrapper - A reusable component for page layout structure
 * 
 * @param {string} props.title - Page title
 * @param {React.ReactNode} props.children - Page content
 */
const PageWrapper = ({ 
  title,
  children, 
}) => {
  const theme = useTheme();
  return (
    <Container
      maxWidth={false}
      disableGutters
      sx={{
        paddingX: pageHorizontalPadding,
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(4),
        backgroundColor: theme.palette.background.default,
      }}
    >
      <Box sx={{ flexGrow: 1 }}>
        {children}
      </Box>
    </Container>
  );
};

export default PageWrapper;